/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { ORGContactInformationComponent} from './ORG_contact_information.component';
import { Util } from 'src/refresh/service/Util';

export class ORGContactInformationValidation extends IValidator {

       constructor(private component: ORGContactInformationComponent) {
             super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            if ( Util.isEmpty(this.component.userEmail)) {
                  this.component.error_email = "ORG_contact_information.errEmailEmpty"; 
                  this.success = false;
            }else if ( !Util.emailValidate(this.component.userEmail)) {
                  this.component.error_email = "ORG_contact_information.errEmailInvalid";
                  this.success = false;
            }
            
            if(Util.isEmpty(this.component.subject) || this.component.subject == '0') {
                  this.component.error_subject = "ORG_contact_information.errSubjectEmpty"; 
                  this.success = false;
            }
            
            if(Util.isEmpty(this.component.userMessage)) {
                  this.component.error_message = "ORG_contact_information.errMessageEmpty"; 
                  this.success = false;
            }

            return this.success;

       }
}

